if ($('.kredietbeschermer-trigger-js').length !== 0) {
	jQuery(document).ready(function($) {

		var form = $('form#verzekering_berekenen');

		var premie = 0;

		var partner = false;

		var verzekerdPersoon = function(){

			var persoon = {
				geboortedatum: '01-01-1990',
				roken: 'nee'
			}

			return persoon;
		}

		var leningGegevens = {
			leenbedrag: 0,
			looptijd: 120,
			productvorm: 'Persoonlijke lening',
		};

		var verzekeringen = {
			orv: false,
			wao: false,
			ww: false,
		};

		var hoofdVerzekerde = new verzekerdPersoon;

		var tweedeVerzekerde = new verzekerdPersoon;

		function getPremie()
		{
			var data = {
				partner: partner,
				bedrag: leningGegevens.leenbedrag,
				looptijd: leningGegevens.looptijd,
				product: leningGegevens.productvorm,
				mainPerson: hoofdVerzekerde,
				secondPerson: tweedeVerzekerde,
				insurances: verzekeringen,
			}

			var errorMatch = new RegExp("error");
			var leeftijdErrorMatch = new RegExp("Leeftijd");

			$.ajax({
				url: '/ajax/getPremie/',
				type: 'POST',
				data: data,
				success: function(data){
					if(data && parseFloat(data) !== 0)
					{
						if(errorMatch.test(data)){
							$('.verzekering-info').hide();
							if(leeftijdErrorMatch.test(data)){
								$('.verzekering-error .error-message p').text('Voor het afsluiten van een verzekering moet u tussen de 18 en 60 jaar oud zijn.');
							}else{
								$('.verzekering-error .error-message p').text('U kunt helaas geen verzekering aanvragen.');
							}
							$('.verzekering-error').show();
							$('.show-when-available').hide();
							$('span.premie').text('€ --,-');
							$('#berekendepremie').text('€ --,-');
						}else{
							$('.verzekering-error').hide();
							$('.show-when-available').show();
							$('span.premie').text($().number_format(data,{numberOfDecimals:2, decimalSeparator: ',',thousandSeparator: ',',symbol: '€'}));
							$('#berekendepremie').text($().number_format(data,{numberOfDecimals:2, decimalSeparator: ',',thousandSeparator: ',',symbol: '€'}));
							$('.verzekering-info').show();
						}
					}else{
						$('.verzekering-info').hide();
						$('.verzekering-error').show();
						$('.show-when-available').hide();
						$('span.premie').text('€ --,-');
						$('#berekendepremie').text('€ --,-');
					}
				}
			});
		}

		function updateData()
		{
			partner = $('select[name="burgerlijkestaat"]').val() == 'alleenstaand' ? false : true;

			leningGegevens.leenbedrag = $('input[name="leenbedrag"]').val();
			leningGegevens.looptijd = $('select[name="looptijd"]').val();
			leningGegevens.productvorm = $('select[name="productvorm"]').val();

			hoofdVerzekerde.roken = $('select[name="roken"]').val();
			hoofdVerzekerde.geboortedatum = $('input[name="geboortedatum"]').val();

			tweedeVerzekerde.roken = $('select[name="rokenPartner"]').val();
			tweedeVerzekerde.geboortedatum = $('input[name="geboortedatumPartner"]').val();

			verzekeringen.orv = $('input[name="orv"]').is(':checked');
			verzekeringen.wao = $('input[name="wao"]').is(':checked');
			verzekeringen.ww = $('input[name=""]').is(':checked');

			if($('input[name="orv"]').is(':checked')){
	            $('li#verzekerd-orv').show();
	        }else{
	            $('li#verzekerd-orv').hide();
	        }

	        if($('input[name="wao"]').is(':checked')){
	            $('li#verzekerd-wao').show();
	        }else{
	            $('li#verzekerd-wao').hide();
	        }

	        if($('input[name="ww"]').is(':checked')){
	            $('li#verzekerd-ww').show();
	        }else{
	            $('li#verzekerd-ww').hide();
	        }

			if (leningGegevens.looptijd > 60) {
	            $('span#verzekerde-looptijd').text(60);
	        }else{
	            $('span#verzekerde-looptijd').text(leningGegevens.looptijd);
	        }

	        $('#verzekerd-bedrag').text($().number_format(leningGegevens.leenbedrag,{numberOfDecimals:0, decimalSeparator: ',',thousandSeparator: '.',symbol: '€'})+',-');
		}

		function setLocalStorage()
		{
			localStorage.setItem("lopendeLening",$('select[name="lopendeLening"]').val());
			localStorage.setItem("leenbedrag",$('input[name="leenbedrag"]').val());
			localStorage.setItem("burgerlijkestaat",$('select[name="burgerlijkestaat"]').val());
			localStorage.setItem("geboortedatum",$('input[name="geboortedatum"]').val());
			localStorage.setItem("orv",$('input[name="orv"]').is(':checked'));
			localStorage.setItem("wao",$('input[name="wao"]').is(':checked'));
			localStorage.setItem("ww",$('input[name="ww"]').is(':checked'));
		}

		form.find('input[type="text"]').on('blur', function(event) {
			if($(this).attr('id') == 'geboortedatum'){
				if($('#geboortedatum').parent().find('small.error').length != 0){
					$('#geboortedatum').parent().find('small.error').remove();
				}
				setLocalStorage();
			}
			if($(this).attr('id') == 'geboortedatumPartner'){
				if($('#geboortedatumPartner').parent().find('small.error').length != 0){
					$(this).parent().find('small.error').remove();
				}
				setLocalStorage();
			}
			updateData();
			getPremie();
		});

		form.find('select, :checkbox, :radio').on('change', function(event) {
			updateData();
			getPremie();
		});

		form.find('input[name="leenbedrag"]').on('blur', function(event) {
			if($(this).val() < 5000)
				$(this).val(5000);
		});

		$('.orv-checkbox input').on('click', function(){

			var inputElem = $(this);
			var inputName = $(this).attr('name');
			var checkedState = $(this).is(':checked');

			//give all checkboxes with the same name, the same state
			$('input[name="'+inputName+'"]').prop('checked', checkedState);

			//if the clicked checkbox is a clone, trigger the checkbox with the event listeners.
			if(inputElem.hasClass('clone'))
				$('input[name="'+inputName+'"]:not(".clone")').change();
		});

		form.find('select[name="looptijd"]').on('change', function(event){
			var looptijd = $(this).val();
			if (looptijd > 60) {
	            $('span#verzekerde-looptijd').text(60);
	        }else{
	            $('span#verzekerde-looptijd').text(looptijd);
	        }
		});

		form.find('select[name="burgerlijkestaat"]').on('change', function(event){

			if( $(this).val() == 'alleenstaand' ){
				$('div#partnerFields').hide();
			}
			else{
				$('div#partnerFields').show();
			}
		});

		$('#trigger-sendinquiry').attr('href', '/offerte-aanvragen/');

		form.find('select[name="lopendeLening"]').on('change', function(event){

			if( $(this).val() == 'ja' ){
				setLocalStorage();
				$('#trigger-sendinquiry').attr('href', '#sendinquiry');
			}
			else{
				setLocalStorage();
				$('#trigger-sendinquiry').attr('href', '/offerte-aanvragen/');
			}
		});

		$('#trigger-sendinquiry').on('click', function(event){
			var geboortedatum = $('#geboortedatum').val();
			var geboortedatumPartner = $('#geboortedatumPartner').val();
			if(geboortedatum === '' || ($('#geboortedatumPartner').is(':visible') && geboortedatumPartner === '')){
				if(geboortedatum === ''){
					if($('#geboortedatum').parent().find('small.error').length == 0){
						$('#geboortedatum').parent().append('<small class="error">Vul een geboortedatum in</small>');
						$('html,body').animate({
							scrollTop: $('#geboortedatum').offset().top - 300
						});
					}
				}
				if($('#geboortedatumPartner').is(':visible') && geboortedatumPartner === ''){
					if($('#geboortedatumPartner').parent().find('small.error').length == 0){
						$('#geboortedatumPartner').parent().append('<small class="error">Vul een geboortedatum in</small>');
						$('html,body').animate({
							scrollTop: $('#geboortedatumPartner').offset().top - 300
						});
					}
					return false;
				}
				return false;
			}

			$('#verzekering_berekenen :input').each(function(){
				var correspondingName = $(this).attr('id');
				var inputVal = $(this).val();

				if($(this).attr('type') == 'checkbox')
					inputVal = $(this).is(':checked') ? 'ja' : 'nee';

				// console.log(correspondingName);
				// console.log('hiddenField: '+$('#sendinquiry input[name="Kredietbeschermer['+correspondingName+']"]') )

				$('#sendinquiry input[name="Kredietbeschermer['+correspondingName+']"]').val(inputVal);

				$('#sendinquiry span').each(function(){
					if( $(this).data('name') == correspondingName ){
						$(this).next().text(inputVal);
					}
				});
			});

			$('html').addClass('no-scroll');

			setLocalStorage();
		});

		closeButton = '';

		$('#sendinquiry a').each(function(){
			if($(this).attr('href') == '#close'){
				closeButton = $(this);
			}
		});

		$('.goto-verzekering').on('click', function(){
			$('html,body').animate({
				scrollTop: $('#verzekering_berekenen').offset().top - 200
			});
		});

		closeButton.on('click',function(){
			$('html').removeClass('no-scroll');
		});

		var url = window.location.href;

		if (url.search("#sendinquiry") >= 0) {
			window.location.replace('#verzekering_berekenen');
		}

		updateData();
		getPremie();

	});


	$(window).load(function() {
	    
		$('input.datum').attr('pattern' ,"(0[1-9]|[12][0-9]|3[01])[-](0[1-9]|1[012])[-](19|20)\\d\\d");

		var url = window.location.href;

		if (url.search("#verzekering_berekenen") >= 0) {
			$('html,body').animate({
				scrollTop: $('#verzekering_berekenen').offset().top - 200
			});
		}

		if($('#form-succes').length != 0){
			$('html,body').animate({
				scrollTop: $('#form-succes').offset().top - 300
			});
		}
		// if($('#sendinquiry').css('opacity') != 0){
		// 	$('#sendinquiry').css('opacity','0');
		// }

	});
}